// driverLocationService.js — שידור מיקום חי של שליחים דרך Realtime Database.

import { ref, set, update, onValue, onDisconnect, serverTimestamp, remove } from "firebase/database";
import { rtdb } from "./firebase";

let watchId = null;

/**
 * השליח מתחיל לשדר מיקום. אם מתנתק — הרשומה נמחקת אוטומטית.
 */
export function startBroadcasting(courierId, { status = "online", deliveryId = null } = {}) {
  const locRef = ref(rtdb, `couriers_live/${courierId}`);
  onDisconnect(locRef).remove();

  if (!navigator.geolocation) {
    console.error("Geolocation לא נתמך");
    return;
  }

  watchId = navigator.geolocation.watchPosition(
    (pos) => {
      set(locRef, {
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
        heading: pos.coords.heading || 0,
        speed: pos.coords.speed || 0,
        status,
        deliveryId,
        updatedAt: serverTimestamp(),
      });
    },
    (err) => console.error("Geo error:", err),
    { enableHighAccuracy: true, maximumAge: 2000, timeout: 10000 }
  );
}

export function stopBroadcasting(courierId) {
  if (watchId !== null) {
    navigator.geolocation.clearWatch(watchId);
    watchId = null;
  }
  remove(ref(rtdb, `couriers_live/${courierId}`));
}

export function setCourierContext(courierId, status, deliveryId) {
  update(ref(rtdb, `couriers_live/${courierId}`), { status, deliveryId });
}

export function listenToCourierLocation(courierId, callback) {
  return onValue(ref(rtdb, `couriers_live/${courierId}`), (snap) => {
    if (snap.exists()) callback(snap.val());
  });
}

export function listenToOnlineCouriers(callback) {
  return onValue(ref(rtdb, "couriers_live"), (snap) => {
    const val = snap.val() || {};
    callback(Object.entries(val).map(([id, d]) => ({ id, ...d })));
  });
}
